import { AbstractControl, ValidationErrors } from "@angular/forms"
import { TranslateService } from '@ngx-translate/core';

export const PasswordStrengthValidator = function (control: AbstractControl): ValidationErrors | null {

  let value: string = control.value || '';
  let msg = "";
  if (!value) {
    return null
  }
  
  let upperCaseCharacters = /[A-Z]+/g;
  let lowerCaseCharacters = /[a-z]+/g;
  let numberCharacters = /[0-9]+/g;
  let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if (upperCaseCharacters.test(value) === false || lowerCaseCharacters.test(value) === false || numberCharacters.test(value) === false || specialCharacters.test(value) === false || value.length < 8) {
    return {
    

      passwordStrength: 'Password must contain the following: numbers, lowercase letters, uppercase letters, or special characters.'
    }

  }

}